type AppcuesUserProperties = Record<string, string | number | boolean>;

interface AppcuesAPI {
  page: () => void;
  identify: (userId: string, properties?: AppcuesUserProperties) => void;
}

declare global {
  interface Window {
    Appcues?: AppcuesAPI;
  }
}

export const trackAppcuesPageView = () => {
  try {
    window.Appcues?.page();
  } catch {
    return;
  }
};

export const identifyAppcuesUser = (
  userId: string,
  properties: AppcuesUserProperties,
) => {
  try {
    window.Appcues?.identify(userId, properties);
  } catch {
    return;
  }
};
